module.exports = __webpack_public_path__ + "img/kongkong.eb4b4e94.png";